import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import router from './router'
import i18nConfig, { loadDynamicContent } from './i18n'

// Import global styles
import './style.css'

// Initialize Firebase (will be configured later)
import { initializeApp } from 'firebase/app'

// Create Vue app
const app = createApp(App)

// Initialize Pinia for state management
const pinia = createPinia()

// Initialize i18n
const i18n = createI18n(i18nConfig)

// Register plugins
app.use(pinia)
app.use(router)
app.use(i18n)

// Register scroll-reveal directive (handled by JavaScript in components)
app.directive('scroll-reveal', {
  mounted() {
    // Directive handled by component JavaScript
  }
})

// Mount app
app.mount('#app')

// Load dynamic content after app is mounted
loadDynamicContent(i18n)